import React, {FC, useEffect, useState} from "react"
import qs from "qs"

import History from "@irati/utils/history"
import {useStartSignUp} from "@irati/signup/hooks"
import ReviewingYourDetails from "../../components/SignUp/Cards/ReviewingYourDetails"
import PageNotFound from "../../components/SignUp/Cards/PageNotFound"
import Header from "../../components/SignUp/Header"
import {SignUpWrapper} from "../../components/SignUp/styled"

const SelfSignUpRedirect: FC = () => {
  const [pageNotFound, setPageNotFound] = useState(false)
  const [startSignUp, {loading}] = useStartSignUp()
  const {firstName, lastName, emailAddress, leadId, licences, companyName} = qs.parse(window.location.search.replace("?", ""))

  const trackingData = {
    company: companyName,
    licence_count: licences || "",
    lead_id: leadId || ""
  }

  useEffect(() => {
    if (!(firstName && lastName && emailAddress && leadId && licences && companyName)) {
      setPageNotFound(true)
    } else {
      const searchParams = new URLSearchParams(location.search)
      const utms = {}

      searchParams.forEach((value, key) => {
        if (key.includes("utm_")) {
          Object.assign(utms, {[key]: value})
        }
      })
      Object.assign(trackingData, utms)
      localStorage.setItem("sbs_params", JSON.stringify(trackingData))
      startSignUp({
        variables: {
          enquiry: {
            firstName,
            lastName,
            emailAddress,
            leadId,
            licences: Number(licences),
            companyName
          }
        }
      })
        .then(({uuid}) => {
          History.replace({pathname: `/signup?uuid=${uuid}&page=welcome`})
        })
        .catch(() => {
          setPageNotFound(true)
        })
    }
  }, [])

  return (
    <SignUpWrapper>
      <Header />
      {pageNotFound ? <PageNotFound /> : <ReviewingYourDetails />}
    </SignUpWrapper>
  )
}

export default SelfSignUpRedirect
